<div class="card m-1">
  <p-breadcrumb [model]="breadItems"></p-breadcrumb>
</div>
<div class="card m-1">
  <div class="card-header bg-gradient-gray-dark text-orange">
    <i class="fa fa-map-marker"></i><strong>&nbsp;Branches</strong>

  </div>
  <div class="card-body">
    <p-table #dtt [value]="linesList" selectionMode="single" [(selection)]="selectedLine" [paginator]="true" [rows]="10" [lazy]="true"
             (onLazyLoad)="loadLines($event)" [totalRecords]="lineTotalRecords" [showCurrentPageReport]="true"
             (onRowSelect)="onRowSelect($event)" currentPageReportTemplate="{first} to {last} of {totalRecords} lines">
      <ng-template pTemplate="caption">
        <div class="row col-12 m-0">
          <span class="p-input-icon-left ml-auto">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="dtt.filterGlobal($event.target.value, 'contains')" placeholder="Search" />
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="body" let-line>
        <tr [pSelectableRow]="line">
          <td pTooltip="{{line.name}}">
            <i *ngIf="line.isMonitored" class="fas fa-desktop {{getViewClass(line)}}"></i>
            <i *ngIf="!line.isMonitored" class="fas fa-times-circle"></i>&nbsp;
            <!--<a [routerLink]="['/cc-portal',line.id]">{{clipstring(line.name)}}</a>-->
            <span>{{line.fakeName}}</span>
          </td>

        </tr>
      </ng-template>

    </p-table>


  </div>
  <div class="overlay dark" *ngIf="loader" style=" height: 550px;">
    <i class="fas fa-2x fa-sync-alt fa-spin"></i>
  </div>
</div>

